import axios from "axios";
import { ip_back } from "../config";

export async function submitClubInquiry(payload) {
  const res = await axios.post(`${ip_back}api/public/club-inquiry`, payload);
  if (res.data?.status !== "success") {
    throw new Error(res.data?.message || "Could not send the inquiry");
  }
  return res.data;
}

function authHeaders() {
  const token = localStorage.getItem("token");
  return { headers: { Authorization: token } };
}

export async function listClubInquiries() {
  const res = await axios.get(`${ip_back}api/admin/club-inquiries`, authHeaders());
  if (res.data?.status !== "success") {
    throw new Error(res.data?.message || "Could not load inquiries");
  }
  return res.data.data || [];
}

export async function patchClubInquiryStatus(inquiryId, status) {
  const res = await axios.patch(
    `${ip_back}api/admin/club-inquiries/${encodeURIComponent(inquiryId)}`,
    { status },
    authHeaders()
  );
  if (res.data?.status !== "success") {
    throw new Error(res.data?.message || "Could not update inquiry");
  }
  return res.data.data;
}
